import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { LoadingScreen } from '@/components/feedback/loading-screen';
import PermissionGuard from '@/auth/guard/permission-guard';
import { OrionAccess, OrionModule, OrionSubmodule } from '@/types';

// Lazy load components
const OpportunitiesListPage = lazy(() => import('@pages/management/accounts/opportunities/list'));
const OpportunityNewPage = lazy(() => import('@pages/management/accounts/opportunities/new'));
const OpportunityDetailPage = lazy(() => import('@pages/management/accounts/opportunities/detail'));
const OpportunityEditPage = lazy(() => import('@pages/management/accounts/opportunities/edit'));
const OpportunitySummaryPage = lazy(
  () => import('@pages/management/accounts/opportunities/summary')
);

export const opportunityRoutes = [
  {
    path: 'opportunities',
    element: (
      <PermissionGuard
        module={OrionModule.ACCOUNT}
        submodule={OrionSubmodule.ACCOUNT.OPPORTUNITY}
        access={OrionAccess.VIEW}
        hasContent
      >
        <Suspense fallback={<LoadingScreen />}>
          <Outlet />
        </Suspense>
      </PermissionGuard>
    ),
    children: [
      {
        path: '',
        element: <OpportunitiesListPage />,
      },
      {
        path: 'new',
        element: (
          <PermissionGuard
            module={OrionModule.ACCOUNT}
            submodule={OrionSubmodule.ACCOUNT.OPPORTUNITY}
            access={OrionAccess.CREATE}
            hasContent
          >
            <OpportunityNewPage />
          </PermissionGuard>
        ),
      },
      {
        path: 'summary',
        element: <OpportunitySummaryPage />,
      },
      {
        path: ':id',
        element: (
          <PermissionGuard
            module={OrionModule.ACCOUNT}
            submodule={OrionSubmodule.ACCOUNT.OPPORTUNITY}
            access={OrionAccess.VIEW}
            hasContent
          >
            <OpportunityDetailPage />
          </PermissionGuard>
        ),
      },
      {
        path: ':id/edit',
        element: (
          <PermissionGuard
            module={OrionModule.ACCOUNT}
            submodule={OrionSubmodule.ACCOUNT.OPPORTUNITY}
            access={OrionAccess.UPDATE}
            hasContent
          >
            <OpportunityEditPage />
          </PermissionGuard>
        ),
      },
    ],
  },
];
